'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _ingredientList = require('./ingredient-list.component');

var _ingredientList2 = _interopRequireDefault(_ingredientList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.ingredientList', []).component('productIngredientList', _ingredientList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/ingredient-list/ingredient-list.module.js